import { DownloadIcon, PrinterIcon, Typography } from "@cpj-ai/panel-npm-package";
import { Button } from "@heroui/react";
import { useState } from "react";

interface DownloadAndPrintCardProps {
  pdfUrl?: string;
  iframeRef?: React.RefObject<HTMLIFrameElement>;
}

const DownloadAndPrintCard = ({ pdfUrl, iframeRef }: DownloadAndPrintCardProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handlePrint = () => {
    if (!iframeRef?.current) return;

    const iframe = iframeRef.current;

    // Wait for iframe to be fully loaded
    if (iframe.contentWindow) {
      iframe.contentWindow.print();
    }
  };

  const handleDownload = async () => {
    if (!pdfUrl) return;

    setIsDownloading(true);
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;

      const filename = `resume_${new Date().toISOString().split("T")[0]}.pdf`;
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex lg:flex-row flex-col gap-4 justify-between items-center bg-[#FDEDD3] px-5 py-2 rounded-lg">
      <Typography className="text-sm font-semibold text-[#C4841D]">
        You can now print or download the resume.
      </Typography>
      <div className="flex gap-4">
        <Button
          className="bg-[#F5A524] text-white w-32"
          startContent={<PrinterIcon width={20} height={20} stroke="#fff" />}
          onClick={handlePrint}
          isDisabled={!pdfUrl}
        >
          Print
        </Button>
        <Button
          className="bg-[#F5A524] text-white w-32"
          startContent={<DownloadIcon width={20} height={20} fill="#fff" />}
          onClick={handleDownload}
          isDisabled={!pdfUrl || isDownloading}
          isLoading={isDownloading}
        >
          {isDownloading ? "Downloading..." : "Download"}
        </Button>
      </div>
    </div>
  );
};

export default DownloadAndPrintCard;
